
import moment from 'moment-timezone';

export default function getWantTimestamp(props) {
  //当前时间
  const nowDate = moment().utc().valueOf(); //当前时间
  switch (props) {
    // 当前时间时间戳
    case "nowData": {
      return nowDate;
    }
    // 三个月前的零点的时间戳
    case "threeMonthDayZero": {
      let month = moment().utc().month() + 1;
      let yearDate = moment().utc().year();
      let quarter=''
      if (month >= 1 && month <= 3) {
        quarter='01'
      } else if (month >= 4 && month <= 6) {
        quarter='04'
      } else if (month >= 7 && month <= 9) {
        quarter='07'
      } else if (month >= 10 && month <= 12) {
        quarter='10'
      }
      return moment.tz(yearDate + '-' + quarter + '-01T00:00:00', 'ETC/GMT+0').valueOf();
    }
    // 今年开始第一天零点的时间戳
    case "thisYearDayZero": {
      let yearDate = moment().utc().year();
      return moment.tz(yearDate + '-01-01T00:00:00', 'ETC/GMT+0').valueOf();
    }
    case "threeMonthDayZeroList": {
      let month = moment().utc().month() + 1;
      let months=[]
      if (month >= 1 && month <= 3) {
        months=[1,2,3]
      } else if (month >= 4 && month <= 6) {
        months=[4,5,6]
      } else if (month >= 7 && month <= 9) {
        months=[7,8,9]
      } else if (month >= 10 && month <= 12) {
        months=[10,11,12]
      }
      return months;
    }

    default: {
      console.log("时间参数错误");
      return 0;
    }
  }
}